import keyBy from 'lodash/keyBy';

export const NODE_NAME = 'flash_card';

export enum FlashCardBlockTypeEnum {
  Orange = 'ORANGE',
  Purple = 'PURPLE',
  Red = 'RED',
  Green = 'GREEN',
  SolidRed = 'SOLID_RED',
  Blue = 'BLUE',
  Black = 'BLACK',
}

export const FLASH_CARDS = [
  {
    id: FlashCardBlockTypeEnum.Orange,
    front: {
      background: '#EB7F36',
      color: '#FFFFFF',
      icon: '#FFFFFF',
      iconHover: 'rgba(253, 243, 220, 0.1)',
    },
    back: {
      background: '#FDF3DC',
      color: '#EB7F36',
      icon: '#E68340',
      iconHover: 'rgba(235, 127, 54, 0.1)',
    },
  },
  {
    id: FlashCardBlockTypeEnum.Purple,
    front: {
      background: '#6357F4',
      color: '#FFFFFF',
      icon: '#FFFFFF',
      iconHover: 'rgba(239, 238, 247, 0.1)',
    },
    back: {
      background: '#EFEEF7',
      color: '#5956EC',
      icon: '#5956EC',
      iconHover: 'rgba(99, 87, 244, 0.1)',
    },
  },
  {
    id: FlashCardBlockTypeEnum.Red,
    front: {
      background: '#D93F4E',
      color: '#FFFFFF',
      icon: '#FFFFFF',
      iconHover: 'rgba(252, 232, 234, 0.1)',
    },
    back: {
      background: '#FCE8EA',
      color: '#D93F4E',
      icon: '#C83341',
      iconHover: 'rgba(217, 63, 78, 0.1)',
    },
  },
  {
    id: FlashCardBlockTypeEnum.Green,
    front: {
      background: '#279257',
      color: '#FFFFFF',
      icon: '#FFFFFF',
      iconHover: 'rgba(244, 249, 246, 0.1)',
    },
    back: {
      background: '#F4F9F6',
      color: '#279257',
      icon: '#1B884C',
      iconHover: 'rgba(39, 146, 87, 0.1)',
    },
  },
  {
    id: FlashCardBlockTypeEnum.Blue,
    front: {
      background: '#2178DF',
      color: '#FFFFFF',
      icon: '#FFFFFF',
      iconHover: 'rgba(243, 248, 253, 0.1)',
    },
    back: {
      background: '#F3F8FD',
      color: '#2178DF',
      icon: '#1769C9',
      iconHover: 'rgba(33, 120, 223, 0.1)',
    },
  },
  {
    id: FlashCardBlockTypeEnum.Black,
    front: {
      background:
        'linear-gradient(91.99deg, #000000 -26.22%, #010101 -14.88%, #020203 -3.54%, #050506 7.8%, #09090B 19.13%, #0E0F11 30.47%, #141518 41.81%, #1A1C20 53.15%, #212329 64.49%, #272A31 75.83%, #2D3038 87.17%, #32363F 98.51%, #363A43 109.85%, #393D47 121.19%, #3A3F49 132.53%, #3B3F49 143.86%)',
      color: '#FFFFFF',
      icon: '#FFFFFF',
      iconHover: 'rgba(242, 242, 242, 0.1)',
    },
    back: {
      background: '#F2F2F2',
      color: '#1C1E22',
      icon: '#000000',
      iconHover: 'rgba(50, 53, 62, 0.1)',
    },
  },
];

export const FLASH_CARDS_BY_KEY = keyBy(FLASH_CARDS, 'id');
